export const breakpoints = {
  xs: '600px',
  sm: '900px',
  md: '1200px',
  lg: '1440px',
};
